<template>
  <div class="my-1 card">
    <h4 class="my-0 py-2 card-header text-info">This shows a simple integration with the backend service</h4>
    <div class="card-body">
      We can show the data that we get from the backend.

      We can implement features on the fron-end to integrate with the backend service as needed.
      <!-- <button class="btn btn-secondary" @click="goback">
        <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>Back
      </button> -->
      <button class="btn btn-info mx-2" v-bind:disabled="nextable" @click="gonext">
        OK
        <font-awesome-icon :icon="['fas', 'arrow-right']"></font-awesome-icon>
      </button>
    </div>
  </div>
</template>
<script>
import Api from "../services/Api";
export default {
  name: "defaultview",
  // mounted() {
  //   // if (this.$route.params.lawfirm) {
  //   //   this.lawfirm = this.$route.params.lawfirm;
  //   // }
  // },
  created() {
    var that = this;
    //that.$root.$emit("stage", 1);
      Api
      .getData("dummy")
      .then(data => {
        let mrdata = data.data;
        that.masterData = mrdata;
        that.$store.commit("populateMR", mrdata);
        that.$root.$emit("done");
        that.$root.$emit("toast", {
          title: "Data Fetched",
          message: "Fetched the lawfirm, services and incident types data"
        });
      })
      .catch(e => {
        //console.log(e);
        that.$root.$emit("done");
        that.$root.$emit("toast", {
          title: "OOPS",
          message: "Error in fetching the data"
        });
      });
  },
  methods: {
    goback: function(oEvent) {
      this.$router.go(-1);
    },
    gonext: function(oEvent) {
      // var services = _.filter(this.services, ser=>{
      //   return ser.isSelected;
      // });

      // this.$store.commit("settings", {
      //   services: services,
      //   //carrier: this.carrier,
      //   lawfirm: this.lawfirm,
      //   incidentType: this.incidentType
      // });
      //this.$router.push({ path: "fill-placeholders" });
    }
  },
  computed: {
    nextable() {
      return !(this.incidentType && this.lawfirm && this.services.length > 0);
    }
  },
  data() {
    return {
      masterData: {},
      createAgainMode:this.$store.getters.createAgainMode
    };
  },
  watch: {
  },
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
